import * as ActionCreators from './actionCreators';
import { methodConstants } from '../constants/methodConstants';
import * as ErrorActions from './errorActions';
import * as Http from '../api/http';
import * as CommonActions from './commonActions';
import RecentRange from '../../fakeData/recentOrdersRange';
import RecentOrdersColumns from '../../fakeData/recentOrdersColumns';
import { appConstants } from '../constants/appConstants';
import { validateManuallyEnteredDate } from '../actions/bankAccountActions';
import { initialManuallyEnteredValues } from  '../initializeObjects/bankAccountFilters';

export const onOrderSearch = (value, prop, isValidate) => (dispatch, getState) => {
  //validating DD-MMM-YYYY format
  if(isValidate &&(prop === appConstants.END_DATE || prop === appConstants.START_DATE)){
    if(prop === appConstants.START_DATE)
      dispatch(validateManuallyEnteredDate(value, appConstants.FROM_DATE));
    else
      dispatch(validateManuallyEnteredDate(value, appConstants.TO_DATE));
  }
  const orderSearchData = getState().orderSearch;
  orderSearchData[prop] = value;
  dispatch(ActionCreators.orderSearch(orderSearchData));
};

export const onOrderSearchSubmit = () => (dispatch, getState) => {
  const orderSearchData = getState().orderSearch;
  const req = {};
  const currentState = getState();
  let edwOrders = CommonActions.getFullApiUrl(methodConstants.EDW_ORDERS, currentState);
  let queryParam = '';
  let isValidEmail = true;
  if (orderSearchData['employeeEmail'] && orderSearchData['employeeEmail'].length > 0) {
    isValidEmail = CommonActions.validateEmail(orderSearchData['employeeEmail']);
  }
  if (isValidEmail) {
    const propSkip = ['programNameString', 'orderNumber', 'programId'];

    Object.keys(orderSearchData).forEach(prop => {
      if (propSkip.indexOf(prop) === -1) {
        if (typeof orderSearchData[prop] === 'object' || prop === appConstants.START_DATE || prop === appConstants.END_DATE) {
          req[prop] = CommonActions.getDateInSpecificFormat(orderSearchData[prop]);
        }else if (orderSearchData[prop].length > 0) {
          req[prop] = orderSearchData[prop];
        }
        if (req[prop]) {
          queryParam += `${prop}=${req[prop]}&`;
        }
      }
    });
    if (queryParam.length > 0) {
      queryParam = queryParam.substr(0, queryParam.length - 1);
      edwOrders += `?${queryParam}`;
    }
    dispatch(ActionCreators.displayLoader(true));
    const request = {
      'nocache': Date.now().toString()
    };
    Http.get(edwOrders, currentState, request).then((res) => {
      dispatch(ActionCreators.searchOrdersList(res.collection));
      dispatch(ActionCreators.displayLoader(false));
      dispatch(ActionCreators.ordersSearchDisplay(true));
    })
      .catch((err) => {
        if (err && err.error && err.error.errorType === 'error.orders-empty') {
          dispatch(ActionCreators.searchOrdersList([]));
        } 
        dispatch(ErrorActions.displayError(err));
      });
  } else {
    const trans = currentState.translations;
    dispatch(ActionCreators.infoMessage(CommonActions.errorMessage(trans['valid-email-provide'])));
    dispatch(ActionCreators.displayMessage(true));
  }

};

export const onSelectRange = (item) => (dispatch) => {
  dispatch(ActionCreators.selectedRange(item));
  dispatch(getOrdersRecent());
};

export const openRangeDropdown = (isOpen) => (dispatch) => {
  dispatch(ActionCreators.isRangeDropdownOpen(isOpen));
};

export const getOrdersRecent = () => (dispatch, getState) => {
  const currentState = getState();
  const selectedRangeValue = currentState.selectedRange.value;
  let edwOrdersApi = CommonActions.getFullApiUrl(methodConstants.EDW_ORDERS_RECENT, currentState);
  edwOrdersApi = CommonActions.modifyString(edwOrdersApi, '{:rangeValue}', selectedRangeValue);
  dispatch(ActionCreators.displayLoader(true));
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(edwOrdersApi, currentState, request).then((res) => {
    const orders = {
      columns: RecentOrdersColumns,
      rows: res.collection
    };
    dispatch(ActionCreators.recentOrdersList(orders));
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });
};

export const initializeRecentOrders = (isUpdate) => (dispatch, getState) => {
  const trans = getState().translations;
  const rangeList = getState().recentRangeList;
  if (Object.keys(rangeList).length === 0 || isUpdate) {
    const range = CommonActions.deepClone(RecentRange);
    range.forEach(r => {
      r.text = CommonActions.firstCharUpper(trans[r.text]);
    });
    const rangeObj = CommonActions.formatDropdown(range, appConstants.RECENT_RANGE_KEYS);
    dispatch(onSelectRange(rangeObj.data[appConstants.RECENT_RANGE_DEFAULT_ONE_MONTH]));
    dispatch(ActionCreators.recentRangeList(rangeObj));
  }
};

export const setDateCalendar = (property, display) => (dispatch) => {
  const isDisplay = display ===  false ? false : true;
  if(property === 'from'){
    dispatch(ActionCreators.isDisplayFromDateCalendar(isDisplay));
  }else if(property === 'to'){
    dispatch(ActionCreators.isDisplayToDateCalendar(isDisplay));
  }else{
    dispatch(ActionCreators.isDisplayFromDateCalendar(isDisplay));
    dispatch(ActionCreators.isDisplayToDateCalendar(isDisplay));
  }
};

export const onDaySelected = (date, modifiers, charCode) => (dispatch) => {
  if (!modifiers.disabled) {
    dispatch(ActionCreators.manuallyEnteredDate(initialManuallyEnteredValues));
    dispatch(onOrderSearch(date, 'startDate'));
    dispatch(setDateCalendar('from', false));
    if (charCode === appConstants.DAY_PICKER_ENTER_ACTION ) { // 0 for react day picker enter
      const ele = document.querySelector('.display-end-toggle .toggle-switch .react-switch-handle');
      if (ele) {
        ele.focus();
      }
    }
  }
  
};

export const onEndDaySelected = (date, modifiers, charCode) => (dispatch) => {
  if (!modifiers.disabled) {
    dispatch(ActionCreators.manuallyEnteredDate(initialManuallyEnteredValues));
    dispatch(onOrderSearch(date, 'endDate'));
    dispatch(setDateCalendar('to', false));
    if (charCode === appConstants.DAY_PICKER_ENTER_ACTION ) { // 0 for react day picker enter
      //const ele = document.querySelector('.display-end-toggle .toggle-switch .react-switch-handle');
      const ele = document.getElementById('submit-search');
      if (ele) {
        ele.focus();
      }
    }
  }
};

